import { render } from "./TheThuChiNganSach.vue?vue&type=template&id=50fb2318"
import script from "./TheThuChiNganSach.vue?vue&type=script&lang=js"
export * from "./TheThuChiNganSach.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__